var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunicationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4385",
    "data-name": "Group 4385",
    transform: "translate(-24 -704)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12701",
    "data-name": "Rectangle 12701",
    width: 30,
    height: 30,
    transform: "translate(24 704)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union_2",
    "data-name": "Union 2",
    transform: "translate(7058 710)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7017.449,14H-7026a3,3,0,0,1-3-3V3a3,3,0,0,1,3-3h14a3,3,0,0,1,3,3v8a3,3,0,0,1-3,3h-.266l1.072,5.744Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -7012.72705078125 16.97771072387695 L -7013.24853515625 14.18290424346924 L -7013.46923828125 12.99947357177734 L -7012.265625 12.99947357177734 L -7012 12.99947357177734 C -7010.89697265625 12.99947357177734 -7009.99951171875 12.10278415679932 -7009.99951171875 11.00059413909912 L -7009.99951171875 3.000643968582153 C -7009.99951171875 1.897483944892883 -7010.89697265625 1.000003933906555 -7012 1.000003933906555 L -7025.99951171875 1.000003933906555 C -7027.10302734375 1.000003933906555 -7028.00048828125 1.897483944892883 -7028.00048828125 3.000643968582153 L -7028.00048828125 11.00059413909912 C -7028.00048828125 12.10278415679932 -7027.10302734375 12.99947357177734 -7025.99951171875 12.99947357177734 L -7017.44921875 12.99947357177734 L -7017.0595703125 12.99947357177734 L -7016.77294921875 13.26288414001465 L -7012.72705078125 16.97771072387695 M -7011.19384765625 19.74320411682129 L -7017.44921875 13.99947357177734 L -7025.99951171875 13.99947357177734 C -7027.65625 13.99947357177734 -7029.00048828125 12.65703392028809 -7029.00048828125 11.00059413909912 L -7029.00048828125 3.000643968582153 C -7029.00048828125 1.342443943023682 -7027.65625 3.965759333368624e-06 -7025.99951171875 3.965759333368624e-06 L -7012 3.965759333368624e-06 C -7010.34375 3.965759333368624e-06 -7008.99951171875 1.342443943023682 -7008.99951171875 3.000643968582153 L -7008.99951171875 11.00059413909912 C -7008.99951171875 12.65703392028809 -7010.34375 13.99947357177734 -7012 13.99947357177734 L -7012.265625 13.99947357177734 L -7011.19384765625 19.74320411682129 Z",
    stroke: "none",
    fill: "#4f5b6d"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21042",
    "data-name": "Ellipse 21042",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(34 716)",
    fill: "#4f5b6d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21043",
    "data-name": "Ellipse 21043",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(38 716)",
    fill: "#4f5b6d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21044",
    "data-name": "Ellipse 21044",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(42 716)",
    fill: "#4f5b6d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicationIcon);
export default __webpack_public_path__ + "static/media/communication_icon.2a8ae4cf183c0b453754a3afa5e495f7.svg";
export { ForwardRef as ReactComponent };